module.exports = __webpack_public_path__ + "img/6.e2dba9db.png";